export default "__VITE_ASSET__00f960f8__"